import { createSlice, isAnyOf } from '@reduxjs/toolkit'
// import { getBOMofSimulationAsync } from 'src/services/costModelling/skuShouldCostWorkbench.services'
import {
  TransformComponentData,
  transformData,
} from 'src/views/pages/costModelling/utils/transformCostBreakdownData'
// const { v4: uuidv4 } = require('uuid');

const initialState = {
  costBreakdownData: [],
  costBreakDownLoader: false,
  selectedComponentName : 'Raw Material',
}

export const getBOMofSimulationSlice = createSlice({
  name: 'get-bom-of-simulation',
  initialState,
  // extraReducers: (builder) => {
  //   builder.addMatcher(isAnyOf(getBOMofSimulationAsync.pending), (state) => {
  //     state.costBreakDownLoader = true
  //   })
  //   builder.addMatcher(isAnyOf(getBOMofSimulationAsync.fulfilled), (state, action) => {
  //     if (action.payload.data.bill_of_material?.length > 0) {
  //       const data = action.payload.data
  //       data?.bill_of_material?.forEach(component => {
  //         component.sub_components.forEach(sub => {
  //           sub.uuid = uuidv4();
  //         });
  //       });
  //       state.costBreakdownData = data
  //     } else {
  //       state.costBreakdownData = []
  //       state.costBreakDownLoader = false
  //     }

  //     state.costBreakDownLoader = false
  //   })
  //   builder.addMatcher(isAnyOf(getBOMofSimulationAsync.rejected), (state, action) => {
  //     state.costBreakDownLoader = false
  //   })
  // },
  reducers: {
    selectedComponentName : (state,action) =>{
      state.selectedComponentName = action?.payload
    },

    updateCostBreakdownData : (state, action) =>{
      console.log('action.payload: ', action.payload);
      state.costBreakdownData = action.payload
    }
  },
})

export const {
  selectedComponentName,
  updateCostBreakdownData
} = getBOMofSimulationSlice.actions

export default getBOMofSimulationSlice.reducer
